import React , {useState} from 'react';
import { getPopularVideos, getVideosByCategory } from '../../redux/actions/videos.action';
import "./_catagory.scss";
import { useDispatch } from 'react-redux';

const keywords = [
    'All',
    'React js',
    'Angular js',
    'React Native',
    'Trailer',
    'Redux',
    'Music',
    'Algorithm Art ',
    'Guitar',
    'English Songs',
    'Coding',
    'Live',
    'Football',
    'Real Madrid',
    'Gatsby',
    'Poor Coder',
    'Music',
 ]


function Catagory() {

    const [activeElement, setActiveElement] = useState('All');

     const dispatch = useDispatch();

    const handleClick = (value) => {
        setActiveElement(value);
        if (value === 'All') {
            dispatch(getPopularVideos())
         } else {
            dispatch(getVideosByCategory(value))
         }
    }
    return (
        <div className="catagory">
        <div className='categoriesBar'>
         {keywords.map((value, i) => (
            <span
               onClick={() => handleClick(value)}
               key={i}
               className={activeElement === value ? 'active' : ''}>
               {value}
            </span>
         ))}
      </div>
      </div>
    )
}

export default Catagory;
